'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.default = formAutosuggestInput;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function formAutosuggestInput(props) {
  var input = props.input,
      _props$meta = props.meta,
      touched = _props$meta.touched,
      error = _props$meta.error,
      type = props.type,
      disabled = props.disabled,
      bottomHint = props.bottomHint,
      field = props.field,
      onSuggestionSelected = props.onSuggestionSelected,
      items = props.items,
      readOnly = props.readOnly,
      placeholder = props.placeholder,
      noIndent = props.noIndent,
      autoWidth = props.autoWidth,
      onBlur = props.onBlur,
      onGetSuggestions = props.onGetSuggestions,
      maxSuggestions = props.maxSuggestions,
      other = (0, _objectWithoutProperties3.default)(props, ['input', 'meta', 'type', 'disabled', 'bottomHint', 'field', 'onSuggestionSelected', 'items', 'readOnly', 'placeholder', 'noIndent', 'autoWidth', 'onBlur', 'onGetSuggestions', 'maxSuggestions']); // eslint-disable-line react/prop-types

  var formGroupClassName = (0, _bind2.default)(props.fieldClassName, { hasError: touched && error, 'margin-vert-10': !noIndent });
  var inputProps = (0, _extends3.default)({}, other, input, {
    disabled: disabled,
    type: type,
    placeholder: placeholder,
    readOnly: readOnly,
    className: 'width-perc-100'
  });

  if (onBlur) {
    var inputOnBlur = input.onBlur;
    inputProps.onBlur = function (e) {
      if (inputOnBlur) {
        inputOnBlur(e);
      }
      onBlur(e);
    };
  }

  return _react2.default.createElement(
    'div',
    { className: formGroupClassName },
    _react2.default.createElement(_components.AutosuggestField, {
      autoWidth: autoWidth,
      field: field,
      onSuggestionSelected: onSuggestionSelected,
      onGetSuggestions: onGetSuggestions,
      items: items,
      inputProps: inputProps,
      maxSuggestions: maxSuggestions
    }),
    touched && error && _react2.default.createElement(
      'div',
      { className: 'fieldErrorText' },
      error
    ),
    bottomHint && _react2.default.createElement(
      'div',
      { className: 'hint small' },
      bottomHint
    )
  );
}

formAutosuggestInput.propTypes = {
  autoWidth: _propTypes2.default.bool,
  bottomHint: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  field: _propTypes2.default.string.isRequired,
  fieldClassName: _propTypes2.default.string,
  hideLabel: _propTypes2.default.bool,
  input: _propTypes2.default.object,
  items: _propTypes2.default.array.isRequired,
  labelClass: _propTypes2.default.string,
  maxSuggestions: _propTypes2.default.number,
  meta: _propTypes2.default.object,
  noIndent: _propTypes2.default.bool,
  onBlur: _propTypes2.default.func,
  onGetSuggestions: _propTypes2.default.func,
  onSuggestionSelected: _propTypes2.default.func.isRequired,
  placeholder: _propTypes2.default.string,
  readOnly: _propTypes2.default.bool,
  type: _propTypes2.default.string
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/formComponents/formAutosuggestInput.js
// module id = 862
// module chunks = 1